module.exports = __webpack_public_path__ + "img/bank-thai-02.4242d0f3.png";